/* Ported from opfor-website — flickering binary grid background */
(function () {
  document.querySelectorAll("[data-binary-grid]").forEach((canvas) => {
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const CELL = 12;
    const FONT_SIZE = 8;
    const FPS_INTERVAL = 1000 / 10;

    let W = 0;
    let H = 0;
    let grid = [];
    let lastTime = 0;
    let rafId = 0;

    function init() {
      const parent = canvas.parentElement;
      W = parent ? parent.clientWidth : window.innerWidth;
      H = parent ? parent.clientHeight : window.innerHeight;
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      canvas.width = Math.floor(W * dpr);
      canvas.height = Math.floor(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      const cols = Math.ceil(W / CELL) + 1;
      const rows = Math.ceil(H / CELL) + 1;
      grid = Array.from({ length: rows }, () =>
        Array.from({ length: cols }, () => (Math.random() < 0.5 ? 0 : 1))
      );
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      ctx.font = `700 ${FONT_SIZE}px ui-monospace, SFMono-Regular, "SF Mono", Menlo, monospace`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillStyle = "rgba(255,77,79,0.14)";

      for (let r = 0; r < grid.length; r++) {
        for (let c = 0; c < grid[r].length; c++) {
          ctx.fillText(String(grid[r][c]), c * CELL + CELL / 2, r * CELL + CELL / 2);
        }
      }
    }

    function loop(ts) {
      rafId = requestAnimationFrame(loop);
      if (ts - lastTime < FPS_INTERVAL) return;
      lastTime = ts;

      const rows = grid.length;
      const cols = grid[0]?.length || 0;
      const count = Math.floor(rows * cols * 0.25);
      for (let i = 0; i < count; i++) {
        const r = Math.floor(Math.random() * rows);
        const c = Math.floor(Math.random() * cols);
        grid[r][c] = Math.random() < 0.5 ? 0 : 1;
      }
      draw();
    }

    init();
    draw();
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      rafId = requestAnimationFrame(loop);
    }
    window.addEventListener(
      "resize",
      () => {
        init();
        draw();
      },
      { passive: true }
    );
  });
})();
